import React from "react";

const PendingChangeItem = (props) => {
    const {
        current,
        pending,
        answerUpdateAction
    } = props;

    return (
        <div>
            {current && (
               <div className={"row"}>
                   <div className={"col-sm-12"}>
                       <strong>Current: </strong>
                       {current}
                   </div>
               </div>
            )}
            {pending && (
                <div className={"row"}>
                    <div className={"col-sm-12"}>
                        <strong>Pending: </strong>
                        {pending}
                    </div>
                </div>
            )}
        </div>
    )
};

export default PendingChangeItem;